
<app-header [showHeaderContent]="true"></app-header>
<app-side-nav [showHeaderContent]="authorized"></app-side-nav>

<div class="fluid-container">
  <router-outlet></router-outlet>
</div>
